import {Action} from '@reduxjs/toolkit'
import moment from 'moment'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Contracts SetFilter] Action',
  ResetFilter: '[Contracts ResetFilter] Action',
}

const initialContractsState: IContractsState = {
  filter: {
    pagination: {
      currentPage: 1,
      totalRecords: 0,
      totalPages: 1,
      skip: 0,
      take: 50,
      reset: true,
      sort: 'name',
      direction: 'asc',
    },
    clientId: '',
    statusId: '',
    typeId: '',
    categoryId: '',
    expiresInThreeMonths: false,
    expiresInSixMonths: false,
  },
}

export interface IContractsState {
  filter?: {
    pagination: any
    clientId: string
    statusId: string
    typeId: string
    categoryId: any
    expiresInThreeMonths: boolean
    expiresInSixMonths: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Contracts', whitelist: ['filter']},
  (state: IContractsState = initialContractsState, action: ActionWithPayload<IContractsState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialContractsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
